export class UserApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCurrentUser() {
    return this.#http.get('/User/current');
  }

  async getUserByRole({ id }) {
    return this.#http.get(`/User/by-role/${id}`);
  }

  async getManageableIds() {
    return this.#http.get('/User/manageable/ids');
  }

  async editProfile(body) {
    return this.#http.put('/User/profile', body);
  }

  resetPassword = async ({ userId, ...body }) => {
    return this.#http.put(`/User/${userId}/reset-password`, body);
  };

  resetInternalPassword = async ({ userId, ...body }) => {
    return this.#http.put(`/User/internal/${userId}/reset-password`, body);
  };
}
